import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/user.template.htm';
import 'dhtmlxMessage';
import Model from '../models/users.model.ts';
import OrganizationsOptions from "views/organizations_options.view.ts";
import VenuesOptions from "views/venues_options.view.ts";
import QueuesOptions from "views/queues_options.view.ts";
import i18n  from "l10n";

export default GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	Model : null,
	id: null,
	editable: null,
	privilegeLevel: "",
	userData: null,
	mode: -1,
	fields: null,
	back: false,
	initialize: function (options) {
		var self = this;
		this.id = options ? options.id : null;
		this.userData = options.data;
		this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

		if(this.id)
		{
			this.editable = true;
			this.model = new Model({id : this.id});
			this.model.fetch({
				success: function(response)
				{
					self.render();
				},
				error: function(response, xhr, status)
				{
					var self = this;
					if (xhr.status == 401) {
						window.open('./','_self');
					} else if(xhr.status == 403) {
						window.open('./','_self');
					}
				}
			});
		}
		else
		{
			this.editable = false;
			this.model = new Model();
			this.render();
		}

		this.fields =
		 {
			name: [this.isEmpty],
			lastName: [this.isEmpty],
			role: [this.isNotSelect],
			//birthday: [this.isEmpty, this.isNotDate]
		};

		if( !this.editable )
		{
            this.fields =  $.extend( this.fields,
            {
                password: [this.isEmpty, this.minLengthNumber, this.maxLengthNumber, this.isNoValidPassword],
                confirm_password: [this.isEmpty, this.sameValues]
            });
		}
		else
		{
		 	this.fields =  $.extend( this.fields,
			{
				password: [this.ignoreEmpty, this.minLengthNumber, this.maxLengthNumber, this.isNoValidPassword],
				confirm_password: [ this.sameValues]
			});
		}
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		var data = $.extend(this.model.toJSON(), { editable: this.editable} );
		var data = $.extend(data, { currentPrivilege: this.privilegeLevel } );
		this.$el.html(this.template(data));

		this.initOptions(data);
	},
	events: {
        "click #submitBtn": "clickOnSubmit",
        "click #submitBack": "clickOnSubmitBack",
        "click #delete": "clickOnDelete",
        "click #reset": "clickOnReset",
        "change #privilegeLevel": "changeRole",
        "change #organizations select": "changeOrganizations",
        "change #venues select": "changeVenue",
        "click #cancel": "goBack",
        "change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
        "focusout #userName input": "validateUserName",
        "focusout #email input": "validateExistEmail",
	},
	validateExistEmail: function(event) {
        var self = this;
        this.has_error4 = false;
        this.has_error4 = this.validateFields({email: [this.isEmpty, this.isEmail]});

        if(this.has_error4 || !event)
            return this.has_error4;

        var element = $(event.currentTarget);
        var email = element.val();
        if(this.model)
        {
            if(this.model.get("email") == email)
            {
                this.clearError(element.parent());
                return;
            }
        }

        $.ajaxDefaultQ({
            url: "rest/api/users/email/exists",
            type: "GET",
            data: "email="+email,
        }).done(function(response, status, xhr){
            if(response.data.value) {
                self.setError($("#email"), i18n.t("user.email_exists"));
                self.has_error4 = true;
                return self.has_error4;
            } else {
                self.clearError($("#email"));
            }
        })
        .fail(function(response) {
            console.error();
            $.notify(
                i18n.t("user.error"),
                { position:"top center", className: "error" }
            );
            self.has_error4 = true;
            return self.has_error4;
        });
	},
	validateUserName: function(event)
	{
	    if( !this.editable ) {
	        var self = this;
            this.has_error3 = false;
            this.has_error3 = this.validateFields({userName: [this.isEmpty, this.minLengthNumber, this.maxLengthNumber]});

            if(this.has_error3 || !event)
                return this.has_error3;

            var element = $(event.currentTarget);
            var userName = element.val();
            if(this.model)
            {
                if(this.model.get("userName") == userName)
                {
                    this.clearError(element.parent());
                    return;
                }
            }

            $.ajaxDefaultQ({
                url: "rest/api/users/exists",
                type: "GET",
                data: "username="+userName,
            }).done(function(response, status, xhr){
                if(response.data.value) {
                    self.setError($("#userName"), i18n.t("user.username_exists"));
                    self.has_error3 = true;
                    return self.has_error3;
                } else {
                    self.clearError($("#userName"));
                }
            })
            .fail(function(response) {
                console.error();
                $.notify(
                    i18n.t("user.error"),
                    { position:"top center", className: "error" }
                );
                self.has_error3 = true;
                return self.has_error3;
            });
	    } else {
	        this.has_error3 = false;
	        return this.has_error3;
		}

	},
	checkPasswords: function() {
        var has_error = false;
        this.Password = $("#password").find("input").val().trim();
        this.confirmPassword = $("#confirm_password").find("input").val().trim();

        if( !this.editable)
        {
            if( this.Password == "" && this.confirmPassword == "") {
                this.setError($("#password"), i18n.t("account.empty_field"));
                this.setError($("#confirm_password"), i18n.t("account.empty_field"));
                has_error = true;
                return has_error;
            }
        }

        if( this.Password != "" || this.confirmPassword != "") {

            if(this.Password == "") {
                this.setError($("#password"), i18n.t("account.type_new_pswd"));
                has_error = true;
            } else {
                if (!this.Password.match(/^(?=.*[a-z]+.*)(?=.*[A-Z]+.*)(?=.+?[0-9]+.*)(?=.*[!@#\$%^&*\-=_+|,.<>?\/\\\}\{\[\];:~]+.*).{6,}$/) ){
                    this.setError($("#password"), i18n.t("account.pswd_prompt"));
                    has_error = true;
                } else
                    this.clearError($("#password"));
            }

            if(this.confirmPassword == "") {
                this.setError($("#confirm_password"), i18n.t("account.confirm_pswd"));
                has_error = true;
            } else {
                if(this.confirmPassword != this.Password ) {
                    this.setError($("#confirm_password"), i18n.t("account.pswds_not_match"));
                    has_error = true;
                } else {
                    this.clearError($("#confirm_password"));
                }
            }

        } else {
            this.clearError($("#confirm_password"));
            this.clearError($("#password"));
        }

        return has_error;
    },
	validateIt: function(event)
	{
		var element = $(event.currentTarget).parent();
		var field = {};
		field[element.prop("id")] = this.fields[element.prop("id")]

		//console.info(field);
		this.validateFields( field );
	},
	clickOnSubmitBack: function(e)
	{
	    this.back = true;

	    this.clickOnSubmit(null);
	},
	clickOnSubmit: function(e)
    {
    	var self = this;
 		var fields = $.extend({}, this.fields);
 		delete fields.password;
 		delete fields.confirm_password;

		var has_error = this.validateFields(fields);
		if(fields)
			has_error = this.validateFields(fields) || has_error

		var role = $("#role").find("select").val();

		has_error = this.venuesOptions.isTheDataWrong() || has_error;
		has_error = this.organizationsOptions.isTheDataWrong() || has_error;
		var has_error2 = this.checkPasswords();
		this.has_error3 = this.validateUserName();
		this.has_error4 = this.validateExistEmail();

		if( !has_error && !has_error2 && !this.has_error3 && !this.has_error4)
		{
			this.model.set("name", $("#name").find("input").val());
			this.model.set("lastName", $("#lastName").find("input").val());
			this.model.set("userName",$("#userName").find("input").val());
			this.model.set("email", $("#email").find("input").val());
			this.model.set("privilegeLevel", this.numberToPrivilegeLevel(role));
			//this.model.set("birthday", $('#birthday input').val());
			this.model.set("phone", "+306981234567");
			this.model.set("privilegeLevel", this.numberToPrivilegeLevel(role));

			if(this.model.get("id") == null) {
			    this.model.set("isLoggedIn", false);
			    this.model.set("loggedInSessions", 0);
			}

			if (this.Password != "" && this.Password != undefined && this.confirmPassword != undefined && this.confirmPassword != "") {
                this.model.set("password", $("#password").find("input").val());
                this.model.set("confirm_password", $("#confirm_password").find("input").val());
            }else {
                delete this.model.attributes.password;
                delete this.model.attributes.confirm_password;
            }
			var venueId = this.venuesOptions.getData();
			if( venueId )
				this.model.set("venueId", venueId);
			//else
			//	this.model.set("venueId", this.userData.venueId);

			var orgId = this.organizationsOptions.getData();
			if( orgId )
				this.model.set("orgId", orgId);
			//else
				//this.model.set("orgId", this.userData.orgId);

			this.showActionProgressBar();

			$.when(window.ping()).then(function(resp) {
			    $.ajaxSetup({
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                    }
                });

                self.model.save(null, {
                    success: function(response)
                    {
                        if(!self.editable)
                            self.queuesOptions.setNewUserId(self.model.get("id"));

                        self.queuesOptions.updateData(
                        {
                            success: _.bind(self.success, self),
                            fail:  _.bind(self.fail, self)
                        });

                        self.hideActionProgressBar();
                    },
                    error: function(response, xhr)
                    {
                        if (xhr.status == 401) {
                            window.open('./','_self');
                        } else if(xhr.status == 403){
                            window.open('./','_self');
                        }

                        var errormsg = "";
                        for (var i=0; i<status.responseJSON.error.causes.length; i++) {
                            errormsg += status.responseJSON.error.causes[i].message + "\n";
                        }
                        $.notify(
                            i18n.t("account.check_errors") + "\n" + errormsg,
                            { position:"top center", className: "error" }
                        );
                        self.hideActionProgressBar();
                    }
                });
            });


		}
		else
		{

			$.notify(
				i18n.t("account.check_errors"),
				{ position:"top center", className: "error" }
			);
		}
    },
    clickOnDelete: function(e) {
        var self = this;
        var removing_model = this.model;
        var agent_name = removing_model.get("userName");

        dhtmlx.confirm({
            type: "confirm",
            text: i18n.t("user.confirm_delete_user")+" \"" + agent_name + "\" ?",
            ok: "Delete",
            cancel: "Cancel",
            callback: function (result) {
                //if yes -> delete the agent and return to agents page
                if (result) {
                    self.showActionProgressBar();
                    removing_model.destroy( {
                        success: function(response) {
                           self.hideActionProgressBar();

                           $.notify(i18n.t("user.user")+" \"" +  agent_name + "\" "+ i18n.t("organization.was_deleted"), { position:"top center", className: "success" });
                           self.goBack();
                        }
                    });
                }
            }
        });
    },
    clickOnReset: function(e)
    {
        $("#name").find("input").val("");
        $("#lastName").find("input").val("");
        //$("#birthday").find("input").val();
		$("#userName").find("input").val("");
        $("#password").find("input").val("");
        $("#confirm_password").find("input").val("");
		$("#email").find("input").val("");
		$("#role").find("select").prop('selectedIndex',0);
		this.organizationsOptions.clearView();
		this.venuesOptions.clearView();
    },
    success: function(response)
    {
		if(this.editable)
		{
			$.notify(i18n.t("user.user_updated"), { position:"top center", className: "success" });

			if(this.back)
			    this.goBack();
			this.back = false;
		}
		else
		{
			$.notify(i18n.t("user.user_added"), { position:"top center", className: "success" });
			this.goBack();
		}
    },
    fail: function(response)
	{

	},
    changeRole: function(event)
	{
		var element = $(event.currentTarget);
		this.isNotSelect("#"+element.parent().prop("id"));
		this.createTools(Number(element.val()));
	},
	changeOrganizations: function()
	{
		//console.info("mode = "+ this.mode);
		if(this.mode > 1)
			this.venuesOptions.load( {org: this.organizationsOptions.getData() } );
	},
	changeVenue: function(e)
	{
		//console.info("mode = "+ this.mode);
		//if(this.mode > 2)
		//	this.queuesOptions.load( this.venuesOptions.getData()  );
		this.clearError("#venues");
	},
	initOptions: function(data)
	{
		var params =
		{
			userPrivilege: this.privilegeLevel,
		};

		this.organizationsOptions = new OrganizationsOptions($.extend(params, { orgId: data.orgId } ));
		this.venuesOptions = new VenuesOptions($.extend(params, { venueId: data.venueId } ));
		this.queuesOptions = new QueuesOptions($.extend(params, { id: this.model.attributes.id} ));

		this.createTools(this.privilegeLevelToNumber(data.privilegeLevel), data);
	},
	createTools: function(index, initData)
	{
		this.mode = index;
		switch(Number(index))
		{
			case 0:
				this.organizationsOptions.clearView();
				this.venuesOptions.clearView();
				//this.queuesOptions.clearView();
			break;
			case 1:
				this.organizationsOptions.load();
				this.venuesOptions.clearView();
				//this.queuesOptions.clearView();
			break;
			case 3:
			case 2:
				this.queuesOptions.clearView();
				if(this.privilegeLevel == 0)
				{
					this.organizationsOptions.load();
					var filter = null;
					if(initData)
						filter = { org: initData.orgId };
					else
						filter = { org: this.organizationsOptions.getData() };

					this.venuesOptions.load(filter);
				}
				else if(this.privilegeLevel == 1)
				{
					this.venuesOptions.load();
				}
			break;
			/*case 3:
				if(this.privilegeLevel == 0)
				{
					this.organizationsOptions.load();
					var filter = null;
					if(initData)
						filter = { org: initData.orgId };
					else
						filter = { org: this.organizationsOptions.getData() };

					this.venuesOptions.load(filter);
				}
				else if(this.privilegeLevel == 1)
				{
					this.venuesOptions.load();
				}

				var venueId = 0;
				if( initData )
					venueId = initData.venueId;
				else if(this.venuesOptions.getData())
					venueId = this.venuesOptions.getData();
				else
					venueId = this.userData.venueId;

				this.queuesOptions.load( venueId );

			break;*/
		}
	},
});

